<div class="skip-link m-2" role="navigation" *ngIf="skipLinks && skipLinks.length > 0" i18n-aria-label="@@skip-to-section" aria-label="Skip to the sections on the page">
    <span i18n="@@skip-to" i18n-aria-label="@@skip-to" aria-label="Skip to">Skip to</span>
    <span *ngFor="let component of skipLinks">
        <a *ngIf="component.Component && component.Component.Title"
           [routerLink] class="skip-link ml-1 primary-link-color"
           fragment="{{component.ComponentId}}"
           (click)="skipToContent(component.ComponentId)">
            {{component.Component.Title}}
        </a>
    </span>
</div>
